/*
 * Native sellmerch product universe for the Shopify homepage.
 * Port of ProductUniverse.tsx + product-universe-layout.ts (no React).
 * Embedded scroll: page owns vertical wheel/touch; drag still pans.
 * Clicks assign to sellmerch.ai in the same tab.
 */
(function (global) {
  'use strict';

  if (global.MrchProductUniverse) {
    global.MrchProductUniverse.boot();
    return;
  }

  var UNIVERSE_COLUMNS = 10;
  var UNIVERSE_MIN_ROWS = 8;
  var UNIVERSE_FOV = 54;
  var UNIVERSE_ZOOM_MS = 520;
  var UNIVERSE_NAV_MS = 400;
  var UNIVERSE_DEPTH = 0.48;
  var PREWARM_MARGIN = '300px';
  var PREVIEW_ORIGIN = 'https://www.sellmerch.ai/garment-previews/v4/';
  var GARMENT_ORIGIN = 'https://www.sellmerch.ai/garments/';
  var UTM =
    'utm_source=mrch_shop&utm_medium=referral&utm_campaign=shop_to_create_web&utm_content=home_universe';
  var BLUEPRINT_ORDER = [706, 951, 256, 1321, 77, 1313, 49, 1132, 1583, 372, 400];

  /* GARMENT_MEDIA: blueprintId, templateId, name, productionCostCents */
  var GARMENT_MEDIA = [
    { blueprintId: 706, templateId: '6808831fc640aaf14d9392ad', name: 'Comfort Colors T-shirt', productionCostCents: 1265 },
    { blueprintId: 1321, templateId: '6808831fc640aaf14d9392ac', name: 'Cotton Ringer T-Shirt', productionCostCents: 1692 },
    { blueprintId: 80, templateId: '6a9fa6c71866abdbde70bed6', name: 'Ultra Cotton Long Sleeve Tee', productionCostCents: 1283 },
    { blueprintId: 49, templateId: '6808831fc640aaf14d9392af', name: 'Heavy Crewneck Sweatshirt', productionCostCents: 1787 },
    { blueprintId: 77, templateId: '6808831fc640aaf14d9392b3', name: 'Heavy Hoodie Sweatshirt', productionCostCents: 2158 },
    { blueprintId: 6, templateId: '6aa034161866abdbde70bed7', name: 'Heavy Cotton Tee', productionCostCents: 968 },
    { blueprintId: 1583, templateId: '68370bf48022ba515af7be39', name: 'Snapback Surf Cap', productionCostCents: 2127 },
    { blueprintId: 88, templateId: '6aa034161866abdbde70bed8', name: "Women's Softstyle Tee", productionCostCents: 1094 },
    { blueprintId: 1313, templateId: '6808831fc640aaf14d9392b1', name: 'Canvas Tote Bag', productionCostCents: 967 },
    { blueprintId: 1459, templateId: '6aa034171866abdbde70bed9', name: 'Comfort Colors Tank Top', productionCostCents: 1979 },
    { blueprintId: 1447, templateId: '6aa038871866abdbde70bedd', name: 'Classic Dad Cap', productionCostCents: 2136 },
    { blueprintId: 400, templateId: '6808831fc640aaf14d9392b0', name: 'Kiss-Cut Stickers', productionCostCents: 142 },
    { blueprintId: 710, templateId: '6aa034171866abdbde70beda', name: 'Comfort Colors Long Sleeve T-Shirt', productionCostCents: 2232 },
    { blueprintId: 1389, templateId: '6aa067381866abdbde70bedf', name: 'Tote Bag (AOP)', productionCostCents: 1263 },
    { blueprintId: 2041, templateId: '6aa038881866abdbde70bede', name: 'Mid Profile Baseball Cap', productionCostCents: 1717 },
    { blueprintId: 1108, templateId: '6aa08e2de782a782054e6d7d', name: 'Low Profile Baseball Cap', productionCostCents: 1538 },
    { blueprintId: 372, templateId: '6aa067381866abdbde70bee0', name: 'Duffel Bag', productionCostCents: 3522 },
    { blueprintId: 1393, templateId: '6aa034171866abdbde70bedb', name: "Women's Boxy Tee", productionCostCents: 1873 },
    { blueprintId: 282, templateId: '6808831fc640aaf14d9392b2', name: 'Matte Vertical Posters', productionCostCents: 496 },
    { blueprintId: 1312, templateId: '6aa034171866abdbde70bedc', name: "Women's Festival Crop Top", productionCostCents: 1590 },
    { blueprintId: 1288, templateId: '6aa08e2ce782a782054e6d61', name: 'Weekender Tote Bag', productionCostCents: 2627 },
    { blueprintId: 607, templateId: '6aa08e2ce782a782054e6d3c', name: 'Beefy-T Short-Sleeve T-Shirt', productionCostCents: 1452 },
    { blueprintId: 800, templateId: '6aa08e2ce782a782054e6d51', name: 'Comfort Colors Tie-Dye Shirt', productionCostCents: 2259 },
    { blueprintId: 951, templateId: '6aa08e2ee782a782054e6dcf', name: 'Can Cooler', productionCostCents: 499 },
    { blueprintId: 256, templateId: '6aa08e2ee782a782054e6dda', name: "Women's Cut & Sew Casual Leggings (AOP)", productionCostCents: 2442 },
    { blueprintId: 1132, templateId: '6aa08e2ee782a782054e6de4', name: "Women's Biker Shorts (AOP)", productionCostCents: 2120 },
  ];

  function displayGarmentName(name) {
    var n = String(name || '').trim();
    if (!n) return '';
    n = n.replace(/^Unisex\s+/i, '');
    if (/^Women's Cut & Sew Casual Leggings(?:\s*\(AOP\))?$/i.test(n)) return "Women's Leggings";
    if (/beefy-?t/i.test(n)) return 'Hanes Beefy-T';
    if (/color blast/i.test(n)) return 'Comfort Colors Tie-Dye Shirt';
    n = n.replace(/Garment[-\s]?Dyed/gi, 'Comfort Colors');
    n = n.replace(/Comfort Colors\s+Comfort Colors/gi, 'Comfort Colors');
    n = n.replace(/Comfort Color(?!s)/gi, 'Comfort Colors');
    return n;
  }

  function formatFromPrice(cents) {
    if (typeof cents !== 'number' || !isFinite(cents) || cents <= 0) return 'View product';
    return 'from $' + (cents / 100).toFixed(2);
  }

  function garmentHref(templateId) {
    return GARMENT_ORIGIN + encodeURIComponent(templateId) + '?' + UTM;
  }

  function garmentImage(blueprintId) {
    var slug = blueprintId === 400 ? '400-sticker' : String(blueprintId);
    return PREVIEW_ORIGIN + slug + '-transparent-512.webp';
  }

  function orderIndex(blueprintId) {
    var i = BLUEPRINT_ORDER.indexOf(blueprintId);
    return i < 0 ? 99 : i;
  }

  function buildCatalog() {
    return GARMENT_MEDIA.slice()
      .sort(function (a, b) {
        return orderIndex(a.blueprintId) - orderIndex(b.blueprintId);
      })
      .map(function (media) {
        return {
          id: media.templateId,
          title: displayGarmentName(media.name),
          image: garmentImage(media.blueprintId),
          price: formatFromPrice(media.productionCostCents),
          href: garmentHref(media.templateId),
        };
      });
  }

  function tileCatalog(catalog) {
    if (!catalog.length) return [];
    var rows = Math.max(UNIVERSE_MIN_ROWS, Math.ceil(catalog.length / UNIVERSE_COLUMNS));
    var length = UNIVERSE_COLUMNS * rows;
    var tiled = new Array(length);
    var i;
    for (i = 0; i < length; i++) tiled[i] = catalog[i % catalog.length];
    return tiled;
  }

  function wrapLattice(value, period, margin) {
    return ((((value + margin) % period) + period) % period) - margin;
  }

  function productSize(width) {
    return width < 640 ? 152 : Math.min(260, width / 5.3);
  }

  function latticeMetrics(viewport, size, cells, gap) {
    if (gap == null) gap = 1.22;
    var step = size * gap;
    var margin = Math.max(size * 2.4, viewport * 0.4);
    return { step: step, period: cells * step, margin: margin };
  }

  function universeLayout(width, height, columns, rows) {
    var size = productSize(width);
    return {
      size: size,
      columns: columns,
      rows: rows,
      x: latticeMetrics(width, size, columns, 1.22),
      y: latticeMetrics(height, size, rows, width < 640 ? 1.42 : 1.2),
    };
  }

  function cameraDistance(height, fov) {
    if (fov == null) fov = UNIVERSE_FOV;
    return height / (2 * Math.tan((fov * Math.PI) / 360));
  }

  function ellipsePose(x, y, width, height, cameraZ) {
    var nx = (2 * x) / width;
    var ny = (2 * y) / height;
    var r2 = nx * nx + ny * ny;
    var cap = r2 / (1 + r2);
    return {
      x: x,
      y: y,
      z: -cameraZ * UNIVERSE_DEPTH * cap,
      rotX: ny * 0.32,
      rotY: -nx * 0.4,
    };
  }

  function easeOutCubic(t) {
    var x = Math.min(1, Math.max(0, t));
    return 1 - Math.pow(1 - x, 3);
  }

  function navigate(href) {
    global.location.assign(href);
  }

  var threePromise = null;

  function resolveThree(candidate) {
    if (candidate && typeof candidate.WebGLRenderer === 'function') return candidate;
    if (candidate && candidate.default && typeof candidate.default.WebGLRenderer === 'function') {
      return candidate.default;
    }
    return null;
  }

  function loadThree(src) {
    var existing = resolveThree(global.THREE);
    if (existing) return Promise.resolve(existing);
    if (threePromise) return threePromise;
    if (!src) return Promise.reject(new Error('three-src'));
    threePromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        var loaded = resolveThree(global.THREE);
        if (loaded) resolve(loaded);
        else reject(new Error('three'));
      };
      script.onerror = function () {
        threePromise = null;
        reject(new Error('three'));
      };
      document.head.appendChild(script);
    });
    return threePromise;
  }

  function showFallback(host, catalog) {
    host.className = 'mrch-product-universe__host mrch-product-universe__fallback';
    host.removeAttribute('tabindex');
    host.setAttribute('aria-label', 'Garment catalog');
    host.innerHTML = '';
    var i;
    for (i = 0; i < catalog.length; i++) {
      var p = catalog[i];
      var a = document.createElement('a');
      a.href = p.href;
      a.setAttribute('aria-label', p.title + ', ' + p.price + '. Customize');
      var img = document.createElement('img');
      img.src = p.image;
      img.alt = p.title;
      img.draggable = false;
      var label = document.createElement('p');
      label.textContent = p.title + ' · ' + p.price;
      a.appendChild(img);
      a.appendChild(label);
      host.appendChild(a);
    }
  }

  function createCard(product) {
    var a = document.createElement('a');
    a.className = 'mrch-product-universe__card';
    a.href = product.href;
    a.setAttribute('aria-label', product.title + ', ' + product.price + '. Customize');
    a.style.width = '240px';
    a.style.height = '240px';
    a.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
    var price = document.createElement('span');
    price.className = 'mrch-product-universe__price';
    price.textContent = product.price;
    var caption = document.createElement('span');
    caption.className = 'mrch-product-universe__caption';
    var title = document.createElement('span');
    title.className = 'mrch-product-universe__title';
    title.textContent = product.title;
    var captionPrice = document.createElement('span');
    captionPrice.className = 'mrch-product-universe__caption-price';
    captionPrice.textContent = product.price;
    caption.appendChild(title);
    caption.appendChild(captionPrice);
    a.appendChild(price);
    a.appendChild(caption);
    return a;
  }

  function mountUniverse(host, catalog, THREE) {
    var products = tileCatalog(catalog);
    if (!products.length) return { destroy: function () {} };

    var links = [];
    var i;
    for (i = 0; i < products.length; i++) {
      var card = createCard(products[i]);
      host.appendChild(card);
      links.push(card);
    }

    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    } catch (err) {
      showFallback(host, catalog);
      return { destroy: function () {} };
    }

    var hover = -1;
    var disposed = false;
    var dirty = true;
    var frame = 0;
    var previous = 0;
    var onScreen = false;
    var pageVisible = !document.hidden;
    var zoom = null;
    var navTimer;
    var down = false;
    var moved = false;
    var exploring = false;
    var x = 0;
    var y = 0;
    var vx = 0;
    var vy = 0;
    var px = 0;
    var py = 0;
    var startX = 0;
    var startY = 0;
    var width = 1;
    var height = 1;
    var size = 240;
    var stepX = 330;
    var stepY = 330;
    var periodX = 1;
    var periodY = 1;
    var marginX = size;
    var marginY = size;
    var homeZ = 1;
    var columns = UNIVERSE_COLUMNS;
    var rows = Math.ceil(products.length / columns);
    var reduced = matchMedia('(prefers-reduced-motion: reduce)');
    var motion = products.map(function () {
      return { hover: 0, strength: 0, dx: 0, dy: 0 };
    });
    var settling = false;
    var lastHover = -2;

    var scene = new THREE.Scene();
    scene.background = null;
    var camera = new THREE.PerspectiveCamera(UNIVERSE_FOV, 1, 1, 10000);
    var projected = new THREE.Vector3();
    var corner = new THREE.Vector3();
    var geometry = new THREE.PlaneGeometry(1, 1);
    var loader = new THREE.TextureLoader();
    loader.crossOrigin = 'anonymous';
    var textureCache = {};
    var materials = [];
    var groups = [];

    function fail() {
      if (disposed) return;
      destroy();
      showFallback(host, catalog);
    }

    function contextLost(event) {
      event.preventDefault();
      fail();
    }

    renderer.domElement.addEventListener('webglcontextlost', contextLost);
    renderer.setClearColor(0, 0);
    if (renderer.setClearAlpha) renderer.setClearAlpha(0);
    renderer.setPixelRatio(Math.min(global.devicePixelRatio || 1, 2));
    host.prepend(renderer.domElement);
    renderer.domElement.style.cssText = 'position:absolute;inset:0;pointer-events:none';

    function stopLoop() {
      if (!frame) return;
      cancelAnimationFrame(frame);
      frame = 0;
    }

    function startLoop() {
      if (disposed || frame || !onScreen || !pageVisible) return;
      dirty = true;
      previous = 0;
      frame = requestAnimationFrame(draw);
    }

    function textureFor(url) {
      if (textureCache[url]) return textureCache[url];
      var texture = loader.load(
        url,
        function () {
          if (disposed) texture.dispose();
          dirty = true;
          startLoop();
        },
        undefined,
        function () {
          fail();
        }
      );
      texture.colorSpace = THREE.SRGBColorSpace;
      textureCache[url] = texture;
      return texture;
    }

    for (i = 0; i < products.length; i++) {
      var group = new THREE.Group();
      var texture = textureFor(products[i].image);
      var j;
      for (j = 12; j >= 0; j--) {
        var material = new THREE.MeshBasicMaterial({
          map: texture,
          color: j ? (j % 2 ? '#a5dcff' : '#d8b1dc') : '#ffffff',
          transparent: true,
          depthWrite: false,
          opacity: j ? 0 : 1,
        });
        materials.push(material);
        var mesh = new THREE.Mesh(geometry, material);
        mesh.userData.depth = j;
        mesh.renderOrder = i * 15 + (12 - j);
        group.add(mesh);
      }
      scene.add(group);
      groups.push(group);
    }

    function setActive(index) {
      var k;
      for (k = 0; k < links.length; k++) {
        if (index === k) links[k].classList.add('is-active');
        else links[k].classList.remove('is-active');
      }
    }

    function resize() {
      dirty = true;
      width = host.clientWidth;
      height = host.clientHeight;
      var layout = universeLayout(width, height, columns, rows);
      size = layout.size;
      stepX = layout.x.step;
      stepY = layout.y.step;
      periodX = layout.x.period;
      periodY = layout.y.period;
      marginX = layout.x.margin;
      marginY = layout.y.margin;
      renderer.setSize(width, height);
      camera.aspect = width / height;
      homeZ = cameraDistance(height);
      if (!zoom) camera.position.set(0, 0, homeZ);
      camera.updateProjectionMatrix();
      camera.updateMatrixWorld();
      startLoop();
    }

    function draw(time) {
      if (disposed || !onScreen || !pageVisible) {
        frame = 0;
        return;
      }
      frame = requestAnimationFrame(draw);
      if (!previous) previous = time;
      if (zoom) {
        var t = easeOutCubic((time - zoom.t0) / UNIVERSE_ZOOM_MS);
        camera.position.set(
          zoom.fromX + (zoom.toX - zoom.fromX) * t,
          zoom.fromY + (zoom.toY - zoom.fromY) * t,
          zoom.fromZ + (zoom.toZ - zoom.fromZ) * t
        );
        camera.updateMatrixWorld();
        if (t < 1) dirty = true;
      }
      var moving = !reduced.matches && !zoom && Math.abs(vx) + Math.abs(vy) > 0.05;
      if (
        !dirty &&
        !moving &&
        !settling &&
        !zoom &&
        hover === lastHover &&
        (hover < 0 || reduced.matches)
      ) {
        return;
      }
      dirty = false;
      lastHover = hover;
      var dt = Math.min((time - previous) / 16.67, 2);
      previous = time;
      if (!down && !reduced.matches && !zoom) {
        x += vx * dt;
        y += vy * dt;
        vx *= Math.pow(0.9, dt);
        vy *= Math.pow(0.9, dt);
      }
      settling = false;
      groups.forEach(function (group, index) {
        var cx = wrapLattice((index % columns) * stepX + size * 0.6 + x, periodX, marginX);
        var cy = wrapLattice(
          Math.floor(index / columns) * stepY + size * 0.64 + (index % 2) * size * 0.23 + y,
          periodY,
          marginY
        );
        var link = links[index];
        if (cx < -size * 1.8 || cx > width + size * 1.8 || cy < -size * 1.8 || cy > height + size * 1.8) {
          group.visible = false;
          if (link) {
            link.style.visibility = 'hidden';
            link.style.pointerEvents = 'none';
          }
          return;
        }
        var selected = hover === index;
        var state = motion[index];
        var blend = 1 - Math.exp(-dt / 18);
        var targetHover = selected && !reduced.matches ? 1 : 0;
        var targetStrength = reduced.matches
          ? 0
          : Math.max(targetHover, Math.min(Math.hypot(vx, vy) / 30, 0.65));
        state.hover += (targetHover - state.hover) * blend;
        state.strength += (targetStrength - state.strength) * blend;
        state.dx +=
          ((selected ? -11 : -Math.max(-18, Math.min(18, vx)) * 0.6) - state.dx) * blend;
        state.dy +=
          ((selected ? 8 : Math.max(-18, Math.min(18, vy)) * 0.6) - state.dy) * blend;
        if (
          Math.abs(state.strength - targetStrength) > 0.001 ||
          Math.abs(state.hover - targetHover) > 0.001
        ) {
          settling = true;
        }
        var pose = ellipsePose(cx - width / 2, height / 2 - cy, width, height, homeZ);
        group.position.set(pose.x, pose.y, pose.z);
        group.rotation.set(pose.rotX, pose.rotY, 0);
        group.children.forEach(function (child) {
          var depth = child.userData.depth;
          var strength = state.strength;
          child.visible = !depth || strength > 0.002;
          child.material.opacity = depth ? strength * 0.24 * (1 - depth / 14) : 1;
          child.position.set(depth * state.dx, depth * state.dy, -depth);
          var scale = size * (1 + state.hover * 0.06) * (1 - depth * 0.014);
          child.scale.set(
            scale,
            scale * (1 + strength * Math.sin(time * 0.002 + depth * 0.5) * depth * 0.002),
            1
          );
          child.rotation.z = depth * strength * Math.sin(time * 0.001) * 0.002;
        });
        group.updateMatrixWorld(true);
        var base = group.children[group.children.length - 1];
        var left = Infinity;
        var top = Infinity;
        var right = -Infinity;
        var bottom = -Infinity;
        var xx;
        var yy;
        for (xx = -0.5; xx <= 0.5; xx += 1) {
          for (yy = -0.5; yy <= 0.5; yy += 1) {
            corner.set(xx, yy, 0);
            base.localToWorld(corner);
            projected.copy(corner).project(camera);
            var screenX = ((projected.x + 1) * width) / 2;
            var screenY = ((1 - projected.y) * height) / 2;
            left = Math.min(left, screenX);
            right = Math.max(right, screenX);
            top = Math.min(top, screenY);
            bottom = Math.max(bottom, screenY);
          }
        }
        var onView =
          right > 8 &&
          left < width - 8 &&
          bottom > 8 &&
          top < height - 8 &&
          right - left > 12 &&
          bottom - top > 12;
        group.visible = right > -80 && left < width + 80 && bottom > -80 && top < height + 80;
        if (link) {
          link.style.transform = 'translate3d(' + left + 'px,' + top + 'px,0)';
          link.style.width = Math.max(0, right - left) + 'px';
          link.style.height = Math.max(0, bottom - top) + 'px';
          link.style.visibility = onView ? 'visible' : 'hidden';
          link.style.pointerEvents = onView && !zoom ? 'auto' : 'none';
          link.dataset.edge = bottom > height - 196 ? 'bottom' : 'top';
        }
      });
      renderer.render(scene, camera);
    }

    function zoomInto(index, href) {
      if (zoom || index < 0 || index >= groups.length) return;
      if (reduced.matches) {
        navigate(href);
        return;
      }
      var group = groups[index];
      zoom = {
        t0: performance.now(),
        fromX: camera.position.x,
        fromY: camera.position.y,
        fromZ: camera.position.z,
        toX: group.position.x,
        toY: group.position.y,
        toZ: Math.max(group.position.z + size * 1.15, 80),
      };
      hover = index;
      vx = vy = 0;
      dirty = true;
      clearTimeout(navTimer);
      navTimer = setTimeout(function () {
        navigate(href);
      }, UNIVERSE_NAV_MS);
      startLoop();
    }

    function focusIn(event) {
      var index = links.indexOf(event.target);
      if (index < 0 || down || zoom) return;
      var rect = event.target.getBoundingClientRect();
      var bounds = host.getBoundingClientRect();
      if (
        rect.left < bounds.left ||
        rect.right > bounds.right ||
        rect.top < bounds.top + 60 ||
        rect.bottom > bounds.bottom - 100
      ) {
        dirty = true;
        x += bounds.left + width / 2 - (rect.left + rect.width / 2);
        y += bounds.top + height / 2 - (rect.top + rect.height / 2);
        vx = vy = 0;
        startLoop();
      }
    }

    function pointerDown(event) {
      if (event.button !== 0 || zoom) return;
      down = true;
      moved = false;
      exploring = false;
      px = startX = event.clientX;
      py = startY = event.clientY;
      vx = vy = 0;
    }

    function pointerMove(event) {
      if (!down || zoom) return;
      var dx = event.clientX - px;
      var dy = event.clientY - py;
      if (Math.hypot(event.clientX - startX, event.clientY - startY) > 5) moved = true;
      if (moved) {
        if (
          event.pointerType === 'touch' &&
          !exploring &&
          Math.abs(event.clientY - startY) >= Math.abs(event.clientX - startX)
        ) {
          px = event.clientX;
          py = event.clientY;
          return;
        }
        exploring = true;
        dirty = true;
        host.setPointerCapture(event.pointerId);
        x += dx;
        y += dy;
        vx = dx;
        vy = dy;
        hover = -1;
        setActive(-1);
        startLoop();
      }
      px = event.clientX;
      py = event.clientY;
    }

    function pointerUp() {
      down = false;
    }

    function cancel() {
      down = false;
      moved = true;
      vx = vy = 0;
    }

    function click(event) {
      if (moved && event.detail !== 0) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }

    function key(event) {
      if (zoom) return;
      var direction = {
        ArrowLeft: [100, 0],
        ArrowRight: [-100, 0],
        ArrowUp: [0, 100],
        ArrowDown: [0, -100],
      };
      if (direction[event.key]) {
        dirty = true;
        event.preventDefault();
        x += direction[event.key][0];
        y += direction[event.key][1];
        startLoop();
      }
    }

    function bindCard(link, index) {
      link.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        hover = index;
        setActive(index);
        dirty = true;
        startLoop();
      });
      link.addEventListener('pointerleave', function () {
        hover = -1;
        setActive(-1);
        dirty = true;
        startLoop();
      });
      link.addEventListener('focus', function () {
        hover = index;
        setActive(index);
        dirty = true;
        startLoop();
      });
      link.addEventListener('blur', function () {
        hover = -1;
        setActive(-1);
        dirty = true;
        startLoop();
      });
      link.addEventListener('click', function (event) {
        if (!event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          zoomInto(index, link.href);
        }
      });
    }

    for (i = 0; i < links.length; i++) bindCard(links[i], i);

    host.addEventListener('focusin', focusIn);
    host.addEventListener('pointerdown', pointerDown);
    host.addEventListener('pointermove', pointerMove);
    host.addEventListener('pointerup', pointerUp);
    host.addEventListener('pointercancel', cancel);
    host.addEventListener('click', click, true);
    host.addEventListener('keydown', key);

    var observer = new ResizeObserver(resize);
    observer.observe(host);

    var visibility = new IntersectionObserver(function (entries) {
      var next = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      if (next === onScreen) return;
      onScreen = next;
      if (next) startLoop();
      else stopLoop();
    });
    visibility.observe(host);

    function onPageVisibility() {
      var next = document.visibilityState !== 'hidden';
      if (next === pageVisible) return;
      pageVisible = next;
      if (next) startLoop();
      else stopLoop();
    }
    document.addEventListener('visibilitychange', onPageVisibility);

    resize();
    startLoop();

    function destroy() {
      if (disposed) return;
      disposed = true;
      clearTimeout(navTimer);
      stopLoop();
      visibility.disconnect();
      observer.disconnect();
      document.removeEventListener('visibilitychange', onPageVisibility);
      host.removeEventListener('focusin', focusIn);
      host.removeEventListener('pointerdown', pointerDown);
      host.removeEventListener('pointermove', pointerMove);
      host.removeEventListener('pointerup', pointerUp);
      host.removeEventListener('pointercancel', cancel);
      host.removeEventListener('click', click, true);
      host.removeEventListener('keydown', key);
      Object.keys(textureCache).forEach(function (url) {
        textureCache[url].dispose();
      });
      materials.forEach(function (m) {
        m.dispose();
      });
      geometry.dispose();
      renderer.domElement.removeEventListener('webglcontextlost', contextLost);
      renderer.dispose();
      if (renderer.domElement.parentNode) renderer.domElement.remove();
    }

    return { destroy: destroy };
  }

  var controllers = {};

  function sectionIdOf(element) {
    var node = element;
    while (node && node.nodeType === 1) {
      if (node.id && node.id.indexOf('shopify-section-') === 0) return node.id;
      node = node.parentNode;
    }
    return null;
  }

  function destroySection(id) {
    if (!id || !controllers[id]) return;
    controllers[id].destroy();
    delete controllers[id];
  }

  function initSection(root) {
    var id = sectionIdOf(root) || 'mrch-product-universe';
    if (controllers[id]) controllers[id].destroy();
    var host = root.querySelector('[data-mrch-universe-host]');
    var threeSrc = root.getAttribute('data-three-src');
    if (!host) return;

    var catalog = buildCatalog();
    var observer = null;
    var started = false;
    var instance = {
      destroy: function () {
        if (observer) observer.disconnect();
        observer = null;
      },
    };
    controllers[id] = instance;

    function start() {
      if (started) return;
      started = true;
      if (observer) observer.disconnect();
      observer = null;
      loadThree(threeSrc)
        .then(function (THREE) {
          if (!controllers[id]) return;
          var mounted = mountUniverse(host, catalog, THREE);
          instance.destroy = function () {
            mounted.destroy();
          };
        })
        .catch(function () {
          if (!controllers[id]) return;
          showFallback(host, catalog);
        });
    }

    if (!('IntersectionObserver' in global)) {
      start();
      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (entry) {
          return entry.isIntersecting;
        })) {
          start();
        }
      },
      { root: null, rootMargin: PREWARM_MARGIN, threshold: 0 }
    );
    observer.observe(root);
  }

  var booted = false;

  function boot() {
    var roots = document.querySelectorAll('[data-mrch-product-universe]');
    var i;
    for (i = 0; i < roots.length; i++) initSection(roots[i]);
    if (booted) return;
    booted = true;
    document.addEventListener('shopify:section:load', function (event) {
      var target = event.target;
      if (target && target.id) destroySection(target.id);
      var root =
        target && typeof target.querySelector === 'function'
          ? target.querySelector('[data-mrch-product-universe]')
          : null;
      if (root) initSection(root);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.id) destroySection(event.target.id);
    });
  }

  global.MrchProductUniverse = { boot: boot };
  if (global.document && typeof global.document.querySelectorAll === 'function') boot();
})(typeof window !== 'undefined' ? window : globalThis);
